module.exports = __webpack_public_path__ + "media/images/event/event-template-am-822c47aad5a42ef74ee6e0fa9334aab2.png";